<template>
    <div id="nissan-quiz-timesup-ipad" class="nissan-quiz-screen">

       <div class="timesupHeadline">THANKS FOR PLAYING</div>
       <div class="timesupTitle">SORRY<br>TIME’S UP</div>
       <div class="timesupSubtitle">DON’T FORGET TO COME<br>BACK AND PLAY AGAIN!</div>
    </div>
</template>

<script>
export default {
  name: 'TimeUpEnd',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';

#nissan-quiz-timesup-ipad {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.timesupHeadline {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 10px;
  font-size: 20px;
}

.timesupTitle {
  text-align: center;
  width: 100%;
  font-size: 40px;
  margin-bottom: 20px;
}

.timesupSubtitle {
  text-align: center;
  width: 100%;
  font-size: 27px;
}
@media only screen and (max-width: 320px) {
  .timesupHeadline {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 10px;
    font-size: 10px;
  }

  .timesupTitle {
    font-size: 30px;
    margin-bottom: 20px;
  }

  .timesupSubtitle {
    font-size: 20px;
  }
}
</style>
